<template>

  <v-app-bar
    app
    color="white"
    flat
    fixed
  >
      <router-link to="/">
        <v-img
          :src="require('@/assets/logo_sans_fond.png')"
          class="Appbar-logo mr-10 mx-2"
          position="left"
          contain
          left
          height="50"
        />
      </router-link>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
          <v-btn
          v-for="item in items"
          :key="item.icon"
          :to="item.link"
          text
          >
            {{ item.title }}
          </v-btn>
      </v-toolbar-items>

      <v-menu class="d-none d-lg-none d-xl-none d-md-none d-xs-block">
        <template v-slot:activator="{on}" class="hidden-md-and-up">
          <v-app-bar-nav-icon v-on="on" class="hidden-md-and-up"></v-app-bar-nav-icon>
        </template>

        <v-list>
          <v-list-item v-for="item in items" :key="item.icon"  :to="item.link">
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
             </v-list-item-content>
          </v-list-item>
        </v-list>

      </v-menu>

    </v-app-bar>

</template>

<script>
import firebase from 'firebase/app'
import { subscribeURL } from "@/common/language"

export default {
  name: "CoreAppBar",
  data () {
    return {
      items: this.fixedItems(),
      unlockAll: false,
    }
  },
  async mounted() {
    await this.updateMenuItems()
    const that = this
    firebase.auth().onAuthStateChanged(async function(user) {
      if (user === null) {
        console.log("AppBar no user")
      }
      await that.updateMenuItems()
    })
  },
  methods: {
    fixedItems() {
      return [
        {
          title: this.$i18n.t("home"),
          link: '/'
        },
        {
          title: this.$i18n.t("programs"),
          link: '/programs',
        },
        {
          title: this.$i18n.t("Search"),
          link: '/search',
        },
        {
          title: this.$i18n.t("MyYoga"),
          link: '/myyoga',
        },
        {
          title: this.$i18n.t("live_scheduler"),
          link: this.livesURL(),
        },
      ]
    },
    subscribeURL() {
      return subscribeURL()
    },
    async updateMenuItems() {
      if (firebase.auth().currentUser !== null) {
        await this.updateUnlockAll()
        if (this.unlockAll !== true) {
          this.items = this.fixedItems().concat([
            {
              title: this.$i18n.t("subscribe"),
              link: this.subscribeURL(),
            },
          ])
        } else {
          this.items = this.fixedItems()
        }
        this.items = this.items.concat([
          {
            title: this.$i18n.t("settings"),
            link: '/settings',
          },
        ])
      } else {
        this.items = this.fixedItems().concat([
          {
            title: this.$i18n.t("subscribe"),
            link: this.subscribeURL(),
          },
          {
            title: this.$i18n.t("login"),
            link: '/login',
          },
        ])
      }
    },
    async updateUnlockAll() {
      const currentUser = firebase.auth().currentUser
      if (currentUser !== null) {
        const unlockAllRef = firebase.database().ref('/users/' + currentUser.uid + '/unlockAll');
        this.unlockAll = await unlockAllRef.once('value').then((snapshot) => {
          return snapshot.val()
        })
      }
    },
    livesURL() {
      const currentUser = firebase.auth().currentUser
      if (currentUser !== null) {
        return '/lives'
      } else {
        return '/liveScheduler'
      }
    }
  },
}
</script>

<style scoped lang="scss">
  .v-toolbar {
    @media screen and (min-width: 200px) and (max-width: 977px) {
     height: 80px;
     padding-right: 20px;
    }
  }
  .Appbar-logo {
    @media screen and (min-width: 200px) and (max-width: 977px) {
      margin-left: 0!important;
      margin-right: 0!important;
    }
    @media screen and (max-width: 1024px){
      margin-left: 40px;
    }
  }
  a {
    text-decoration: none;
  }
  .v-btn--active, .v-list-item--active {
    background-color: $base-color;
    color: #FFF!important;
  }
</style>
